var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ais-pagination", {
    attrs: { padding: 1 },
    on: { "page-change": _vm.pageChange },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({
          currentRefinement,
          nbPages,
          pages,
          isLastPage,
          refine,
          createURL,
        }) {
          return [
            nbPages > 1
              ? _c(
                  "div",
                  {
                    staticClass:
                      "display-flex tablet:display-none flex-content-center flex-wrap flex-items-center",
                  },
                  [
                    currentRefinement >= 1
                      ? _c(
                          "a",
                          {
                            staticClass: "button flat clear",
                            attrs: {
                              href: createURL(currentRefinement - 1),
                              "aria-label": "Previous Page",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return refine(currentRefinement - 1)
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "margin-right-sm",
                              attrs: {
                                icon: _vm.$v6.solid.faAngleLeft,
                                size: "lg",
                                "aria-hidden": "true",
                              },
                            }),
                            _vm._v("\n        Prev\n      "),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          padding: "var(--button-padding)",
                          "vertical-align": "middle",
                          "border-style": "solid",
                          "border-width": "0",
                          "margin-bottom": "var(--button-margin-bottom)",
                        },
                      },
                      [
                        _vm._v(
                          "\n        Page " +
                            _vm._s(currentRefinement + 1) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !isLastPage
                      ? _c(
                          "a",
                          {
                            staticClass: "button flat clear",
                            attrs: {
                              href: createURL(currentRefinement + 1),
                              "aria-label": "Next Page",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return refine(currentRefinement + 1)
                              },
                            },
                          },
                          [
                            _vm._v("\n        Next\n        "),
                            _c("font-awesome-icon", {
                              staticClass: "margin-left-sm",
                              attrs: {
                                icon: _vm.$v6.solid.faAngleRight,
                                size: "lg",
                                "aria-hidden": "true",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            nbPages > 1
              ? _c(
                  "div",
                  {
                    staticClass:
                      "display-none tablet:display-flex flex-content-center flex-wrap flex-items-center pagination-large-screen",
                    staticStyle: { width: "100%" },
                  },
                  [
                    currentRefinement > 1
                      ? _c(
                          "a",
                          {
                            staticClass: "button flat clear",
                            attrs: {
                              href: createURL(currentRefinement - 1),
                              "aria-label": "Previous Page",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return refine(currentRefinement - 1)
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "margin-right-sm",
                              attrs: {
                                icon: _vm.$v6.solid.faAngleLeft,
                                size: "lg",
                                "aria-hidden": "true",
                              },
                            }),
                            _vm._v("\n        Prev\n      "),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    currentRefinement > 1
                      ? _c(
                          "a",
                          {
                            staticClass: "button flat clear",
                            attrs: { href: createURL(1) },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return refine(0)
                              },
                            },
                          },
                          [_vm._v("\n        1\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    currentRefinement > 1
                      ? _c(
                          "div",
                          {
                            staticClass: "padding-horizontal-3xs",
                            staticStyle: {
                              "--button-color": "--body-color",
                              padding: "var(--button-padding)",
                              "vertical-align": "middle",
                              "border-style": "solid",
                              "border-width": "0",
                              "margin-bottom": "var(--button-margin-bottom)",
                            },
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("\n        ...\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(pages, function (page) {
                      return _c(
                        "button",
                        {
                          key: page,
                          class: [
                            page === currentRefinement ? "flat" : "",
                            "flat clear",
                          ],
                          style: [
                            page === currentRefinement
                              ? {
                                  background: "var(--fa-dk-blue)",
                                  color: "var(--white)",
                                }
                              : "",
                          ],
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return refine(page)
                            },
                          },
                        },
                        [_vm._v("\n        " + _vm._s(page + 1) + "\n      ")]
                      )
                    }),
                    _vm._v(" "),
                    currentRefinement < nbPages - 2
                      ? _c(
                          "div",
                          {
                            staticClass: "padding-horizontal-3xs",
                            staticStyle: {
                              "--button-color": "--body-color",
                              padding: "var(--button-padding)",
                              "vertical-align": "middle",
                              "border-style": "solid",
                              "border-width": "0",
                              "margin-bottom": "var(--button-margin-bottom)",
                            },
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("\n        ...\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    currentRefinement < nbPages - 2
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "--button-color": "--body-color",
                              padding: "var(--button-padding)",
                              "vertical-align": "middle",
                              "border-style": "solid",
                              "border-width": "0",
                              "margin-bottom": "var(--button-margin-bottom)",
                            },
                          },
                          [_vm._v("\n        " + _vm._s(nbPages) + "\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    currentRefinement < nbPages - 2
                      ? _c(
                          "a",
                          {
                            staticClass: "button flat clear",
                            attrs: {
                              href: createURL(currentRefinement + 1),
                              "aria-label": "Next Page",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return refine(currentRefinement + 1)
                              },
                            },
                          },
                          [
                            _vm._v("\n        Next\n        "),
                            _c("font-awesome-icon", {
                              staticClass: "margin-left-sm",
                              attrs: {
                                icon: _vm.$v6.solid.faAngleRight,
                                size: "lg",
                                "aria-hidden": "true",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }